import Whatsapp from './Chat/Chat'
import CourierLoadSheet from './CourierLoadSheet/CourierLoadSheet'
import DispatchDetail from './CourierLoadSheet/DispatchDetails'
import OrderDetails from './OrderDetails/OrderDetails'
import Orders from './Orders'
import Support from '../support/Support/Support'
import Received from './Returns/InnerPages/Received/Received'
import ReceivedDetail from './Returns/InnerPages/Received/ReceivedDetail'
import Returning from './Returns/InnerPages/Returning/Returning'
import Returns from './Returns/Returns'
import SplitOrder from './SplitAndMerge/SplitOrder'
import StockOut from './StockOut/StockOut'
import StockOutDetail from './StockOut/StockOutDetail'
import RequestTrackingTest from '../../app/common/RequestTrackingTest'
export const ROUTES = [
  {
    component: Orders,
    isProtected: true,
    showMenu: true,
    path: '/orders',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: OrderDetails,
    isProtected: true,
    showMenu: true,
    path: '/orders/detail/:id',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Returns,
    isProtected: true,
    showMenu: true,
    path: '/orders/returns',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Returning,
    isProtected: true,
    showMenu: true,
    path: '/orders/returns/returning',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Received,
    isProtected: true,
    showMenu: true,
    path: '/orders/returns/received',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ReceivedDetail,
    isProtected: true,
    showMenu: true,
    path: '/orders/returns/received/:batch_id/:courier_id',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: CourierLoadSheet,
    isProtected: true,
    showMenu: true,
    path: '/orders/courier-load-sheet',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: DispatchDetail,
    isProtected: true,
    showMenu: true,
    path: '/orders/courier-load-sheet/details/:group_by/:id',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Support,
    isProtected: true,
    showMenu: true,
    path: '/orders/support',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Support,
    isProtected: true,
    showMenu: true,
    path: '/orders/support/:id',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: StockOut,
    isProtected: true,
    showMenu: true,
    path: '/orders/stock-out',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: StockOutDetail,
    isProtected: true,
    showMenu: true,
    path: '/orders/stock-out/:id',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: SplitOrder,
    isProtected: true,
    showMenu: true,
    path: '/orders/split/:id',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Whatsapp,
    isProtected: true,
    showMenu: true,
    path: '/orders/whatsapp',
    slug: 'orders',
    title: 'orders',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: RequestTrackingTest,
    isProtected: true,
    showMenu: true,
    path: '/orders/request-tracking-test',
    slug: 'orders',
    title: 'Request Tracking Test',
    redirectTo: '/auth/login',
    isExact: true,
  },
]
